package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Category(
    @SerialName("gridProducts")
    val gridProducts: List<GridProduct?>?=null,
    @SerialName("id")
    val id: String?,
    @SerialName("name")
    val name: String?,
    @SerialName("__typename")
    val typename: String?
)